export default "__VITE_ASSET__DcfhF0cr__"